import React, { useState, useEffect } from "react";
import styles from "./styles/Navigation.module.css";
import { useLanguage } from "../LanguageContext";
import logo from "../assets/images/nav_logo.png";
// import logoMobile from "../assets/images/logo_mobile.png";
import googleplay from "../assets/images/googleplay.png";
import appstore from "../assets/images/appstore.png";

function Navigation() {
    const { language, toggleLanguage, t } = useLanguage();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 576);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 576);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isMobileMenuOpen && isMobileView) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isMobileMenuOpen, isMobileView]);

    return (
        <nav className={styles.navbar}>
            <div className={styles.navbarContainer}>
                <div className={styles.logoSection}>
                    <a href="/">
                        <img src={logo} alt="logo" className={`${styles.logo} ${styles.desktopLogo}`} />
                        <img src={logo} alt="logo" className={`${styles.logo} ${styles.mobileLogo}`} />
                    </a>
                </div>

                {/* Desktop Links */}
                <ul className={styles.navLinks}>
                    <li>
                        <a href="/#advantages">{t("navigation.advantages")}</a>
                    </li>
                    <li>
                        <a href="/#about">{t("navigation.about")}</a>
                    </li>
                    <li>
                        <a href="/#terms">{t("navigation.terms")}</a>
                    </li>
                    <li>
                        <a href="/#calculator">{t("navigation.calculator")}</a>
                    </li>
                    <li>
                        <a href="/#faq">{t("navigation.faq")}</a>
                    </li>
                </ul>

                {/* Language Toggle */}
                <button className={styles.languageToggle} onClick={toggleLanguage}>
                    {language}
                </button>

                {/* Hamburger Menu */}
                <button className={styles.mobileMenuToggle} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                    <svg
                        className={`${styles.menuIcon} ${isMobileMenuOpen ? styles.open : ""}`}
                        width="25"
                        height="12"
                        viewBox="0 0 25 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect className={`${styles.line} ${styles.line1}`} width="25" height="1" fill="white" />
                        <rect className={`${styles.line} ${styles.line2}`} y="11" width="25" height="1" fill="white" />
                    </svg>
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            {isMobileView && (
                <div className={`${styles.mobileMenu} ${isMobileMenuOpen ? styles.open : ""}`}>
                    <div className={styles.mobileMenuContent}>
                        <ul className={styles.mobileLinks}>
                            <li>
                                <a href="/#advantages" onClick={() => setIsMobileMenuOpen(false)}>
                                    {t("navigation.advantages")}
                                </a>
                            </li>
                            <li>
                                <a href="/#about" onClick={() => setIsMobileMenuOpen(false)}>
                                    {t("navigation.about")}
                                </a>
                            </li>
                            <li>
                                <a href="/#terms" onClick={() => setIsMobileMenuOpen(false)}>
                                    {t("navigation.terms")}
                                </a>
                            </li>
                            <li>
                                <a href="/#calculator" onClick={() => setIsMobileMenuOpen(false)}>
                                    {t("navigation.calculator")}
                                </a>
                            </li>
                            <li>
                                <a href="/#faq" onClick={() => setIsMobileMenuOpen(false)}>
                                    {t("navigation.faq")}
                                </a>
                            </li>
                        </ul>
                        <div className={styles.dividerContainer}>
                            <div className={styles.divider}></div>
                        </div>
                        <div className={styles.mobileLanguage}>
                            <span
                                onClick={() => language !== "EN" && toggleLanguage()}
                                className={language === "EN" ? styles.activeLang : styles.inactiveLang}
                            >
                                EN
                            </span>
                            <span style={{ margin: "0 5px" }}>/</span>
                            <span
                                onClick={() => language !== "AM" && toggleLanguage()}
                                className={language === "AM" ? styles.activeLang : styles.inactiveLang}
                            >
                                AM
                            </span>
                        </div>
                        <div className={styles.mobileApps}>
                            <a href="https://apps.apple.com/" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>
                                <img src={appstore} alt="App Store" />
                            </a>
                            <a href="https://play.google.com/" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>
                                <img src={googleplay} alt="Google Play" />
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
}

export default Navigation;